import { render, staticRenderFns } from "./UserCoinCollectionCount.vue?vue&type=template&id=5bb291e3&"
import script from "./UserCoinCollectionCount.vue?vue&type=script&lang=js&"
export * from "./UserCoinCollectionCount.vue?vue&type=script&lang=js&"
import style0 from "./UserCoinCollectionCount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports